import { SvgIcon, type SvgIconProps } from './svgIcon'

type Props = SvgIconProps & {
  fillColor?: string
  strokeColor?: string
}

export function CheckCircleIcon({
  width = 24,
  height = 24,
  fillColor = '#50F000',
  strokeColor = '#121212',
  ...props
}: Props) {
  return (
    <SvgIcon
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      {...props}>
      <rect width={width} height={height} rx="12" fill={fillColor} />
      <path
        d="M17.3307 8L10.2161 16L6.66406 12.5685"
        stroke={strokeColor}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </SvgIcon>
  )
}
